import React from 'react';
import "./WebServicesApis.scss";

//images
import imgwebServicesApis from "../../../assets/connectors/WebServicesApis.png";
import { useTranslation } from 'react-i18next';

const WebServicesApis = () => {
    const {t} = useTranslation()
    
    return (
        <div className="container-webservicesapis">
            <div className="img-webservicesapis">
                <img src={imgwebServicesApis} alt="" />
            </div>
            <div className="texts-webservicesapis">
                <h1>{t("connectors.web_services.title")}</h1>
                <p>{t("connectors.web_services.section_text")}</p>
                {/* <button id="btn-webservicesapis">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default WebServicesApis